module.exports = __webpack_public_path__ + "static/img/banner-csr-12.7091eb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-csr-12.jpg
// module id = a6yj
// module chunks = 99